import { Component, Input } from '@angular/core';
import { PermissionsService } from '../services/permissions/permissions.service';

export type CustomerMenuTab = {
  icon: string;
  class: string;
  menuText: string;
  menuLink: string[];
  disabled?: boolean;
  disabledTooltip?: string;
};

@Component({
    selector: 'customer-wrapper',
    templateUrl: './customer-wrapper.component.html',
    styleUrls: ['./customer-wrapper.component.scss'],
    standalone: false
})
export class CustomerWrapperComponent {
  @Input() showBreadcrumb = true;

  menuTabs: CustomerMenuTab[];

  constructor(private permissionsService: PermissionsService) {
    const isSynxInternal = this.permissionsService.isSynxInternal;

    this.menuTabs = [
      { icon: 'customer-list.svg', class: '', menuText: 'Customer List', menuLink: ['/', 'home', 'customer-management', 'list'] },
      { icon: 'line-chart.svg', class: '', menuText: 'Customer Usage', menuLink: ['/', 'home', 'customer-management', 'usage'] },
      {
        icon: 'metrics-dashboard.svg', class: '', menuText: 'Metrics Dashboard',
        menuLink: ['/', 'home', 'customer-management', 'metrics'],
        disabled: !isSynxInternal,
        disabledTooltip: 'Only Available to Select People',
      },
    ];
  }
}
